var map = {
	"./Learn-1.png": 3262,
	"./Learn-2.png": 5061,
	"./block-1.png": 3411,
	"./block-2.png": 5080,
	"./crash-1.png": 913,
	"./crash-2.png": 1930,
	"./phish-1.png": 4264,
	"./tailwind.css": 5357
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;